import { render, staticRenderFns } from "./RefForm.vue?vue&type=template&id=22e97a97&"
import script from "./RefForm.vue?vue&type=script&lang=ts&"
export * from "./RefForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports